import React, { useState } from "react";
import {
    Button,
    Col,
    Row,
    Input,
    Label,
} from "reactstrap";

import { FormGroup } from "components/common";
import { useForm } from "hooks";
import { Trans } from "react-i18next";
import moment from "moment";
import { DailyTable } from "pages/PayrollHrNew/AttendanceReport/DailyTable";

const AttendanceTable = ({ client, employee, t, match }) => {
    const { Form } = useForm();
    const fixedTime = 8;

    const initial_form = {
        employee_name: null,
        employee_id: employee.id,
        date: '',
        full_month: false,
    }

    const [searchForm, setSearchForm] = useState(initial_form)
    const [searchTrigger, setSearchTrigger] = useState(false)

    const _fetchEmployeesAttendance = async (pageIndex, pageSize) => {
        try {
            var attendance = await client.get(`employees/${employee.id}/attendance`, { params: { ...{ 'ordering': `time_date`, 'offset': pageIndex, 'limit': pageSize }, ...searchForm } }).get('data')
            return { ...attendance, items: attendance.results.map((item) => handleDateAndTime(item)) }
        }
        catch (err) {
            console.error(err)
            return "Error at loading attendance report"
        }
    }


    const resetSearchFields = () => {
        setSearchForm(initial_form)
        setSearchTrigger(!searchTrigger)
    }

    const handleDateAndTime = (item) => {
        let duration = null
        let intervallMins
        let start = item.time_in ? moment(item.time_in, "HH:mm:ss") : ""
        let end = item.time_out ? moment(item.time_out, "HH:mm:ss") : ""

        if (start & end) {
            let difference = moment.duration(end.diff(start)) || 0;
            let hours = difference.hours(), minutes = difference.minutes()
            duration = `${hours}h ${minutes}m`
            intervallMins = (fixedTime * 60) - ((hours * 60) + minutes)  //fixed-worked = difference in mins
        }

        item.duration = duration || 0
        item.time_in = start ? start.format("HH:mm") : ""
        item.time_out = end ? end.format("HH:mm") : ""
        item.intervallMins = intervallMins
        return item
    }


    return (
        <div className="attendance">
            <Row>
                <div className="col-xs-12 col-md-12 mx-1">
                    <Form className="form d-flex">
                        <FormGroup className="mx-2">
                            <label><Trans>Date</Trans></label>
                            <Input
                                type="date"
                                name="date"
                                className=""
                                value={searchForm.start_date}
                                onChange={(e) => setSearchForm({ ...searchForm, time_date: e.target.value })}
                            />
                        </FormGroup>
                        <FormGroup check className="d-flex align-items-end mx-2 mb-2">
                            <Input name="full_month" type="checkbox" checked={searchForm.full_month} onChange={(e) => setSearchForm({ ...searchForm, full_month: !searchForm.full_month })} />
                            <Label check htmlFor="full_month"><Trans>Full Month</Trans></Label>
                        </FormGroup>
                        <div className="ml-2 mt-3 d-flex align-items-end">
                            <Button color="success" className="mr-2" onClick={() => setSearchTrigger(!searchTrigger)}><Trans>Search</Trans></Button>
                            <Button className="mr-2" onClick={resetSearchFields}><Trans>Reset</Trans></Button>
                        </div>
                    </Form>
                </div>
            </Row>
            <Row>
                <Col className="col-xs-12 col-md-12 mx-1">
                    <DailyTable t={t} fetch={_fetchEmployeesAttendance} UpdateTimeInOut={() => { }} setSelectedRows={() => { }} refetch={searchTrigger} readOnly />
                </Col>
            </Row>
        </div>
    );
};


export default AttendanceTable;
